import { ShowGame } from "components/content-pages/HallOfFamePreview";
import { BlockHeading } from "components/landing-pages/BlockHeading";
import { HallOfFameBlock } from "dtos/content/landing-pages/HallOfFameBlock";

export const HallOfFameBlockDisplay = (props: { block: HallOfFameBlock }) => {
    const { block } = props;
    const { items, actionText, actionUrl, heading } = block;

    return (
        <div className="grid">
            {heading && (
                <div className="g-col-12">
                    <BlockHeading block={block} />
                </div>
            )}

            {items.map(item => {
                const { code, title, playerCount, roundCount, imageUrl, heading } = item;

                return (
                    <ShowGame
                        label={heading}
                        key={code}
                        g={{
                            code,
                            dateModified: 0,
                            imageUrl,
                            playerCount,
                            roundCount,
                            hasSocialLinks: false,
                            id: 0,
                            name: title,
                            isImageHidden: false,
                            prompt: ".",
                        }}
                    />
                );
            })}

            {actionText && actionUrl && (
                <div className="g-col-12 text-center">
                    <a className="btn btn-primary" href={actionUrl}>
                        {actionText}
                    </a>
                </div>
            )}
        </div>
    );
};
